export enum CategoryType {
  MAIN = "main",
  SUB = "sub",
}

export default function extractMainOrSubCategoriIdFromSelectValue(
  selectValue: string,
  categoryType: CategoryType
) {
  let index;
  switch (categoryType) {
    case CategoryType.SUB:
      index = 0;
      break;
    case CategoryType.MAIN:
      index = 1;
      break;
    default:
      index = 0;
      break;
  }

  return selectValue.split
    ? Number(selectValue.split("-")[index])
    : selectValue;
}
